import * as R from 'ramda' // why ramda? she returns is a copy of the list. It does not modify the original.

export const sortJust = (fn, data) => R.sort(fn, data)
